import { isPlatformBrowser } from "@angular/common";
import { Component, inject, OnInit, PLATFORM_ID, signal } from "@angular/core";
import { RouterLink } from "@angular/router";
import { LoginService } from "../../../core/services/login.service";

@Component({
  selector: "app-cover-landing",
  standalone: true,
  imports: [RouterLink],

  templateUrl: "./cover-landing.component.html",
  styleUrl: "./cover-landing.component.css",
})
export class CoverLandingComponent implements OnInit {
  private _loginService = inject(LoginService);
  isLoggedIn = signal<boolean>(false);
  hasToken: boolean = false;
  id = inject(PLATFORM_ID);

  timing = setInterval(() => {
    if (!this.isLoggedIn()) {
      this.isLoggedIn.set(this._loginService.isLoggedIn());
      clearInterval(this.timing);
      return;
    }
  }, 500);

  ngOnInit() {
    if (isPlatformBrowser(this.id)) {
      this.hasToken = !!localStorage.getItem("token");
    }
  }
}
